var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meals-date__weekly"},[_c('strong',[_vm._v("\n        "+_vm._s(_vm.weekDay)+"\n        "),(_vm.evaluation)?_c('span',{class:'meal-evaluation-value '+_vm.evaluationColor},[_vm._v(_vm._s(_vm.evaluationValue))]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fullDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }